import { AccessorialType } from 'types/accessorial.types'

export const ACCESSORIAL_OPTIONS: { value: AccessorialType; label: string }[] =
    [
        { value: 'shipperLiftgateService', label: 'Shipper Liftgate' },
        { value: 'consigneeLiftgateService', label: 'Consignee Liftgate' },
        {
            value: 'residentialPickupDelivery',
            label: 'Residential Pickup/Delivery',
        },
        { value: 'limitedAccess', label: 'Limited Access' },
        { value: 'shipperAppointmentFee', label: 'Shipper Appointment' },
        { value: 'consigneeAppointmentFee', label: 'Consignee Appointment' },
        { value: 'reweighFee', label: 'Reweigh' },
        { value: 'detentionFee', label: 'Detention' },
        { value: 'storageFee', label: 'Storage' },
        { value: 'redeliveryFee', label: 'Redelivery' },

        { value: 'lumperFee', label: 'Lumper' },
        { value: 'reconsignmentFee', label: 'Reconsignment' },
        {
            value: 'overlengthOverweightSurcharge',
            label: 'Overlength/Overweight Surcharge',
        },
        { value: 'heatedService', label: 'Heated Service' },
        { value: 'refrigeratedService', label: 'Refrigerated Service' },
        { value: 'afterHoursService', label: 'After Hours Service' },
        { value: 'additionalStopFee', label: 'Additional Stop' },
        { value: 'tarpService', label: 'Tarp Service' },
        { value: 'sortSeg', label: 'Sort/Seg' },
        { value: 'reclassFee', label: 'Reclass' },
        { value: 'protectFromFreeze', label: 'Protect-from-Freeze' },
        { value: 'tankerEndorsement', label: 'Tanker Endorsement' },
        { value: 'blanketsBlanketWrap', label: 'Blankets / Blanket Wrap' },
        { value: 'rework', label: 'Rework' },
        { value: 'crossdock', label: 'Crossdock' },
        { value: 'palletExchangeInOut', label: 'Pallet Exchange (In/Out)' },
        { value: 'nonStackable', label: 'Non-Stackable' },
        { value: 'dangerousGoods', label: 'Dangerous Goods' },
    ]
